import { useEffect, useRef, useMemo } from 'react';
import Cookie from 'js-cookie';
import { playSound } from '../../utils/soundUtils';
import successSound from '../../public/assets/sounds/success.mp3';
import errorSound from '../../public/assets/sounds/error.mp3';
import notificationSound from '../../public/assets/sounds/notification.mp3';
import sendMessageSound from '../../public/assets/sounds/sendingMessage.mp3';
import receiveMessageSound from '../../public/assets/sounds/receivingMessage.mp3';
var audio = {
    success: successSound,
    error: errorSound,
    notification: notificationSound,
    sendMessage: sendMessageSound,
    receiveMessage: receiveMessageSound
};
var Sound = function Sound(_ref) {
    var _audio$type;
    var type = _ref.type, play = _ref.play, setPlay = _ref.setPlay;
    var enable_audio = useMemo(function () {
        var userCookie = Cookie.get('user');
        if (!userCookie)
            return false;
        try {
            var _JSON$parse;
            return ((_JSON$parse = JSON.parse(userCookie)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.details) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.audio) || false;
        }
        catch (_unused) {
            return false;
        }
    }, []);
    var audioSource = type ? (_audio$type = audio[type]) !== null && _audio$type !== void 0 ? _audio$type : audio.notification : null;
    var audioRef = useRef(null);
    useEffect(function () {
        if (!enable_audio || !audioSource)
            return;
        var cleanup = playSound(audioSource, audioRef, play, setPlay);
        return cleanup;
    }, [play, audioSource, setPlay, enable_audio]);
    return null;
};
export default Sound;
